<div class="flex flex-col gap-4 w-full">
  <p-card>
    <div class="flex flex-col gap-2 sm:flex-row justify-start sm:justify-between">
      <div class="header-title-table text-center sm:text-start">
        {{ isEdit ? 'Editar' : 'Nova' }} Notificação
      </div>
      <div class="w-full flex flex-col justify-start  sm:flex-row gap-2 sm:justify-end sm:items-end">
        <p-button (click)="onClickCancel()" label="Cancelar" styleClass="btn-outlined">
          <app-icon-close-square color="currentColor"/>
        </p-button>
        @if (isEdit) {
          <p-button *hasPermission="'excluir_notificacao'"
                    (click)="onClickDelete()" label="Excluir" styleClass="btn-outlined">
            <app-icon-bold-trash color="currentColor"/>
          </p-button>
        }
        <p-button (click)="onClickSave()" label="Salvar" styleClass="btn-red">
          <app-icon-save color="currentColor"/>
        </p-button>
      </div>
    </div>
  </p-card>
  <p-card>
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>Dados Iniciais</p-accordion-header>
        <p-accordion-content>
          <p-fluid>
            <form [formGroup]="dadosIniciaisForm"
                  class="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              <div class="flex flex-col gap-2 justify-start">
                <label for="superintendencia">Superintendência<span class="required">*</span></label>
                <p-select [invalid]="isFormControlInvalid(dadosIniciaisForm, 'superintendencia')"
                          [options]="superintendenciaOptions"
                          appendTo="body"
                          formControlName="superintendencia"
                          id="superintendencia"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>
                @if (isFormControlInvalid(dadosIniciaisForm, 'superintendencia')) {
                  <p-message severity="error" size="small" variant="simple">O campo Superintendência é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="diretoria">Diretoria</label>
                <p-select [invalid]="isFormControlInvalid(dadosIniciaisForm, 'diretoria')"
                          [options]="diretoriaOptions"
                          appendTo="body"
                          formControlName="diretoria"
                          id="diretoria"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>

              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="gerencia">Gerência</label>
                <input [invalid]="isFormControlInvalid(dadosIniciaisForm, 'gerencia')"
                       formControlName="gerencia"
                       id="gerencia"
                       maxlength="50"
                       pInputText
                       placeholder="Digite"
                />
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="cpf">Item CFF</label>
                <input [invalid]="isFormControlInvalid(dadosIniciaisForm, 'cff')"
                       formControlName="cff"
                       id="cff"
                       maxlength="100"
                       pInputText
                       placeholder="Digite"/>

              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="numeroNotificacao">N NOT</label>
                <input [invalid]="isFormControlInvalid(dadosIniciaisForm, 'numeroNotificacao')"
                       formControlName="numeroNotificacao"
                       id="numeroNotificacao"
                       maxlength="25"
                       pInputText
                       placeholder="Digite"/>
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="dataNotificacao">Data NOT<span class="required">*</span></label>
                <p-date-picker [invalid]="isFormControlInvalid(dadosIniciaisForm, 'dataNotificacao')"
                               appendTo="body"
                               dateFormat="dd/mm/yy"
                               formControlName="dataNotificacao"
                               id="dataNotificacao"
                               placeholder="DD/MM/AAAA"
                               showIcon="true"
                >
                </p-date-picker>
                @if (isFormControlInvalid(dadosIniciaisForm, 'dataNotificacao')) {
                  <p-message severity="error" size="small" variant="simple">O campo Data NOT é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="concessionaria">Concessionária<span class="required">*</span></label>
                <p-select [invalid]="isFormControlInvalid(dadosIniciaisForm, 'concessionaria')"
                          [options]="concessionariaOptions"
                          appendTo="body"
                          formControlName="concessionaria"
                          id="concessionaria"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>
                @if (isFormControlInvalid(dadosIniciaisForm, 'concessionaria')) {
                  <p-message severity="error" size="small" variant="simple">O campo Concessionária é
                    obrigatório.
                  </p-message>
                }
              </div>
            </form>
          </p-fluid>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </p-card>

  <p-card>
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>Processos, Identificação e Valores</p-accordion-header>
        <p-accordion-content>
          <p-fluid>
            <form [formGroup]="processosForm"
                  class="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              <div class="flex flex-col gap-2 justify-start">
                <label for="categoria">Categoria</label>
                <input [invalid]="isFormControlInvalid(processosForm, 'categoria')"
                       formControlName="categoria"
                       id="categoria"
                       maxlength="50"
                       pInputText
                       placeholder="Digite"
                />
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="processo">Processo<span class="required">*</span>
                  <app-abrir-sei modo="link" [texto]="processosForm.get('processo')?.value"/></label>
                @if (showInputMaskProcesso) {
                  <p-input-mask
                    [invalid]="isFormControlInvalid(processosForm, 'processo')"
                    [mask]="getMaskProcesso()"
                    [unmask]="false"
                    formControlName="processo"
                    id="processo"
                    placeholder="___.________/____-__"
                  />
                } @else {
                  <input
                    pInputText
                    id="processo"
                    formControlName="processo"
                    [invalid]="isFormControlInvalid(processosForm, 'processo')"
                    placeholder="Digite"
                    [maxlength]="50"
                  />
                }
                @if (isFormControlInvalid(processosForm, 'processo')) {
                  <p-message severity="error" size="small" variant="simple">O campo Processo é
                    obrigatório.
                  </p-message>
                }
              </div>

              <div class="flex flex-col gap-2 justify-start">
                <label for="descricao">Descrição</label>
                <input [invalid]="isFormControlInvalid(processosForm, 'descricao')"
                       formControlName="descricao"
                       id="descricao"
                       maxlength="4000"
                       pInputText
                       placeholder="Digite"
                />
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="motivo">Motivo<span class="required">*</span></label>
                <p-select [invalid]="isFormControlInvalid(processosForm, 'motivo')"
                          [options]="motivoOptions"
                          appendTo="body"
                          formControlName="motivo"
                          id="motivo"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione">
                </p-select>
                @if (isFormControlInvalid(processosForm, 'motivo')) {
                  <p-message severity="error" size="small" variant="simple">O campo Motivo é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="status">Status<span class="required">*</span></label>
                <p-select [invalid]="isFormControlInvalid(processosForm, 'status')"
                          [options]="statusOptions"
                          appendTo="body"
                          formControlName="status"
                          id="status"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>
                @if (isFormControlInvalid(processosForm, 'status')) {
                  <p-message severity="error" size="small" variant="simple">O campo Status é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="fase">Fase<span class="required">*</span></label>
                <p-select [invalid]="isFormControlInvalid(processosForm, 'fase')"
                          [options]="faseOptions"
                          appendTo="body"
                          formControlName="fase"
                          id="fase"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>
                @if (isFormControlInvalid(processosForm, 'fase')) {
                  <p-message severity="error" size="small" variant="simple">O campo Fase é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="valorP0">Valor P0</label>
                <input
                  [invalid]="isFormControlInvalid(processosForm, 'valorP0')"
                  [maxDigits]="19"
                  [maxInteger]="'10000000000000000'"
                  [valorExcedeMaxFlag]="{ value: valorExcedeMax }"
                  appCurrencyMax
                  formControlName="valorP0"
                  pInputText
                  placeholder="R$"
                />
                <!--  @if (valorExcedeMax) {
                     <p-message severity="error" size="small" variant="simple">
                         O valor máximo permitido é R$ 10.000.000.000.000.000,00
                     </p-message>
                 } -->
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="valorAtual">Valor Atual</label>
                <input
                  [invalid]="isFormControlInvalid(processosForm, 'valorAtual')"
                  [maxDigits]="19"
                  [maxInteger]="'10000000000000000'"
                  [valorExcedeMaxFlag]="{ value: valorExcedeMax }"
                  appCurrencyMax
                  formControlName="valorAtual"
                  pInputText
                  placeholder="R$"
                />
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="numeroTap">N TAP</label>
                <input [invalid]="isFormControlInvalid(processosForm, 'numeroTap')"
                       formControlName="numeroTap"
                       id="numeroTap"
                       maxlength="20"
                       pInputText
                       placeholder="Digite"
                />
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="tipoTap">Tipo TAP @if (processosForm.get('fase')?.value === 12) {
                  <span class="required">*</span>
                }</label>
                <p-select [invalid]="isFormControlInvalid(processosForm, 'tipoTap')"
                          [options]="tipoTapOptions"
                          appendTo="body"
                          formControlName="tipoTap"
                          id="tipoTap"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>
                @if (isFormControlInvalid(processosForm, 'tipoTap')) {
                  @for (key of objectKeys(processosForm.get('tipoTap')?.errors); track $index) {
                    <p-message
                      severity="error"
                      size="small"
                      variant="simple"
                    >
                      {{ processosForm.get('tipoTap')?.errors?.[key] }}
                    </p-message>
                  }
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="dataTap">Data TAP @if (processosForm.get('status')?.value === 7) {
                  <span class="required">*</span>
                }</label>
                <p-date-picker [invalid]="isFormControlInvalid(processosForm, 'dataTap')"
                               appendTo="body"
                               dateFormat="dd/mm/yy"
                               formControlName="dataTap"
                               id="dataTap"
                               placeholder="DD/MM/AAAA"
                               showIcon="true"
                >
                </p-date-picker>
                @if (isFormControlInvalid(processosForm, 'dataTap')) {
                  @for (key of objectKeys(processosForm.get('dataTap')?.errors); track $index) {
                    <p-message
                      severity="error"
                      size="small"
                      variant="simple"
                    >
                      {{ processosForm.get('dataTap')?.errors?.[key] }}
                    </p-message>
                  }
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="valorTap">Valor
                  TAP @if (processosForm.get('tipoTap')?.value === 2 && processosForm.get('fase')?.value === 12) {
                    <span class="required">*</span>
                  }</label>
                <input
                  [invalid]="isFormControlInvalid(processosForm, 'valorTap')"
                  [maxDigits]="19"
                  [maxInteger]="'10000000000000000'"
                  [valorExcedeMaxFlag]="{ value: valorExcedeMax }"
                  appCurrencyMax
                  formControlName="valorTap"
                  pInputText
                  placeholder="R$"
                />
                @if (isFormControlInvalid(processosForm, 'valorTap')) {
                  @for (key of objectKeys(processosForm.get('valorTap')?.errors); track $index) {
                    <p-message
                      severity="error"
                      size="small"
                      variant="simple"
                    >
                      {{ processosForm.get('valorTap')?.errors?.[key] }}
                    </p-message>
                  }
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="situacaoTap">Situação TAP</label>
                <p-select [invalid]="isFormControlInvalid(processosForm, 'situacaoTap')"
                          [options]="situacaoTapOptions"
                          appendTo="body"
                          formControlName="situacaoTap"
                          id="situacaoTap"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>
                @if (isFormControlInvalid(processosForm, 'situacaoTap')) {
                  @for (key of objectKeys(processosForm.get('situacaoTap')?.errors); track $index) {
                    <p-message
                      severity="error"
                      size="small"
                      variant="simple"
                    >
                      {{ processosForm.get('situacaoTap')?.errors?.[key] }}
                    </p-message>
                  }
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="andamento">Andamento<span class="required">*</span></label>
                <p-date-picker [invalid]="isFormControlInvalid(processosForm, 'andamento')"
                               appendTo="body"
                               dateFormat="dd/mm/yy"
                               formControlName="andamento"
                               id="andamento"
                               placeholder="DD/MM/AAAA"
                               showIcon="true"
                >
                </p-date-picker>
                @if (isFormControlInvalid(processosForm, 'andamento')) {
                  <p-message severity="error" size="small" variant="simple">O campo Andamento é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="localizacao">Localização</label>
                <input [invalid]="isFormControlInvalid(infracaoForm, 'localizacao')"
                       formControlName="localizacao"
                       id="localizacao"
                       maxlength="50"
                       pInputText
                       placeholder="Digite"
                />

              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="infracoes">Infrações
                </label>
                <p-inputNumber
                  (onInput)="onInfracoesInput($event)"
                  [invalid]="isFormControlInvalid(processosForm, 'infracoes')"
                  [maxFractionDigits]="0"
                  [max]="9007199254740991"
                  [minFractionDigits]="0"
                  [min]="0"
                  [useGrouping]="false"
                  formControlName="infracoes"
                  id="infracoes"
                  mode="decimal"
                  placeholder="Digite"
                >
                </p-inputNumber>
                @if (isFormControlInvalid(processosForm, 'infracoes')) {
                  <p-message severity="error" size="small" variant="simple">O campo Infrações é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="grupo">Grupo
                </label>
                <p-select [invalid]="isFormControlInvalid(processosForm, 'grupo')"
                          [options]="grupoOptions"
                          appendTo="body"
                          formControlName="grupo"
                          id="grupo"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                >
                </p-select>
                @if (isFormControlInvalid(processosForm, 'grupo')) {
                  <p-message severity="error" size="small" variant="simple">O campo Grupo é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="nivel">Nível
                </label>
                <p-select [invalid]="isFormControlInvalid(processosForm, 'nivel')"
                          [options]="nivelOptions"
                          appendTo="body"
                          formControlName="nivel"
                          id="nivel"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione">
                </p-select>
                @if (isFormControlInvalid(processosForm, 'nivel')) {
                  <p-message severity="error" size="small" variant="simple">O campo Nível é
                    obrigatório.
                  </p-message>
                }
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="avanco">Avanço
                </label>
                <p-inputNumber
                  (onBlur)="onAvancoBlur($event)"
                  (onFocus)="onAvancoFocus($event)"
                  (onInput)="onAvancoInput($event)"
                  [invalid]="isFormControlInvalid(processosForm, 'avanco')"
                  [maxFractionDigits]="2"
                  [max]="100"
                  [minFractionDigits]="0"
                  [min]="0"
                  formControlName="avanco"
                  id="avanco"
                  locale="pt-BR"
                  mode="decimal"
                  placeholder="%"
                  prefix="% "
                >
                </p-inputNumber>

                @if (isFormControlInvalid(processosForm, 'avanco')) {
                  <p-message severity="error" size="small" variant="simple">
                    O campo Avanço é obrigatório.
                  </p-message>
                }
              </div>

              <div class="flex flex-col gap-2 justify-start">
                <label for="judicial">Judicial @if (processosForm.get('fase')?.value === 11) {
                  <span class="required">*</span>
                }</label>
                <input [invalid]="isFormControlInvalid(processosForm, 'judicial')"
                       formControlName="judicial"
                       id="judicial"
                       pInputText
                       placeholder="Digite"/>
                @if (isFormControlInvalid(processosForm, 'judicial')) {
                  @for (key of objectKeys(processosForm.get('judicial')?.errors); track $index) {
                    <p-message
                      severity="error"
                      size="small"
                      variant="simple"
                    >
                      {{ processosForm.get('judicial')?.errors?.[key] }}
                    </p-message>
                  }
                }
              </div>
            </form>
          </p-fluid>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </p-card>

  <p-card>
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>Localização e Observações</p-accordion-header>
        <p-accordion-content>
          <p-fluid>
            <form [formGroup]="infracaoForm"
                  class="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              <div class="flex flex-col gap-2 justify-start">
                <label for="rodovia">Rodovia</label>
                <input [invalid]="isFormControlInvalid(infracaoForm, 'rodovia')"
                       formControlName="rodovia"
                       id="rodovia"
                       maxlength="100"
                       pInputText
                       placeholder="Digite"
                />
              </div>
              <div class="flex flex-col gap-2 justify-start">
                <label for="curso">Curso<span class="required">*</span></label>
                <p-select [invalid]="isFormControlInvalid(infracaoForm, 'curso')"
                          [options]="cursoOptions"
                          appendTo="body"
                          formControlName="curso"
                          id="curso"
                          optionLabel="nome"
                          optionValue="id"
                          placeholder="Selecione"
                />
                @if (isFormControlInvalid(infracaoForm, 'curso')) {
                  <p-message severity="error" size="small" variant="simple">O campo Curso é
                    obrigatório.
                  </p-message>
                }
              </div>

              <div class="flex flex-col gap-2 justify-start  sm:col-span-2 lg:col-span-3 xl:col-span-4">
                <label for="observacao">Observações</label>
                <textarea
                  [invalid]="isFormControlInvalid(infracaoForm, 'observacao')"
                  formControlName="observacao"
                  pInputTextarea
                  placeholder="Digite"
                >
                                </textarea>
              </div>
            </form>
          </p-fluid>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </p-card>

  @if (isEdit && extraColumns.length > 0) {
    <p-card>
      <p-accordion value="0">
        <p-accordion-panel value="0">
          <p-accordion-header>Informações Extras</p-accordion-header>
          <p-accordion-content>
            <p-fluid>
              <div class="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                @for (col of extraColumns; track col.id) {
                  <div class="flex flex-col gap-2 justify-start">
                    <label [for]="col.id">{{ col.label }}</label>
                    <input [id]="col.id"
                           [type]="col.type === 'date' ? 'date' : col.type === 'number' ? 'number' : 'text'"
                           [value]="getExtraValue(col.id)"
                           (change)="setExtraValue(col.id, $any($event.target).value)"
                           pInputText/>
                  </div>
                }
              </div>
            </p-fluid>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </p-card>
  }
</div>

<!-- confirm salvar -->
<app-confirm-dialog (cancel)="showConfirmSaveDialog = false"
                    (confirm)="save()"
                    [(visible)]="showConfirmSaveDialog"
                    [closable]="false"
                    cancelLabel="Agora não"
                    confirmLabel="Sim, salvar"
                    headerTitle="Salvar Notificação"
                    message="Deseja realmente salvar esta notificação?">
</app-confirm-dialog>

<!-- confirm editar -->
<app-confirm-dialog (cancel)="showConfirmEditDialog = false"
                    (confirm)="save()"
                    [(visible)]="showConfirmEditDialog"
                    [closable]="false"
                    cancelLabel="Agora não"
                    confirmLabel="Sim, salvar"
                    headerTitle="Salvar Notificação"
                    message="Deseja realmente salvar as alterações da notificação?">
</app-confirm-dialog>

<!-- confirm cancelar salvar -->
<app-confirm-dialog (cancel)="showCancelSaveDialog = false"
                    (confirm)="resetAndGoBack('create')"
                    [(visible)]="showCancelSaveDialog"
                    [closable]="false"
                    cancelLabel="Não, manter dados"
                    confirmLabel="Sim, cancelar criação"
                    headerTitle="Cancelar Criação de Notificação"
                    message="Deseja realmente cancelar a criação da notificação? Todos os dados inseridos serão perdidos.">
</app-confirm-dialog>


<!-- confirm cancelar editar -->
<app-confirm-dialog (cancel)="showCancelEditDialog = false"
                    (confirm)="resetAndGoBack('edit')"
                    [(visible)]="showCancelEditDialog"
                    [closable]="false"
                    cancelLabel="Não, manter dados"
                    confirmLabel="Sim, cancelar edição"
                    headerTitle="Cancelar Edição de Notificação"
                    message="Deseja realmente cancelar as alterações da notificação? Todos os dados inseridos serão perdidos.">
</app-confirm-dialog>

<!-- confirm excluir -->
<app-confirm-dialog (cancel)="onCancelDelete()"
                    (confirm)="delete()"
                    [(visible)]="showConfirmDeleteDialog"
                    [closable]="false"
                    cancelLabel="Não, manter"
                    confirmLabel="Sim, excluir"
                    headerTitle="Excluir Notificação"
                    message="Deseja realmente excluir essa notificação? Todos os dados serão perdidos.">
</app-confirm-dialog>

<!-- confirm formatação processo SEI -->
<app-confirm-dialog (cancel)="onClickAjustarProcesso()"
                    (confirm)="openConfirmSaveDialog()"
                    [(visible)]="showConfirmProcessoSEIFormatDialog"
                    [closable]="false"
                    cancelLabel="Não, ajustar"
                    confirmLabel="Sim, prosseguir"
                    headerTitle="Número do Processo"
                    message="O número do processo está fora do padrão SEI, deseja continuar mesmo assim?"
                    width="40vw"
>
</app-confirm-dialog>

